






import {
  Component,
  Vue
} from 'vue-property-decorator';
import CookiePreferences from '@/cookie-notice/inputs/CookiePreferences.vue';
import MatomoCookieService from '@/services/matomo/MatomoCookieService';
import MatomoMessage from '@/matomo/message/MatomoMessage';
import { MatomoActions } from '@/matomo/MatomoActions';

@Component({
  components: {CookiePreferences}
})
export default class CookiePreferencePage extends Vue {
  private matomoCookieService = MatomoCookieService.singleton();

  private optOutMessage = new MatomoMessage([MatomoActions.optOut]);

  private reload() {
    this.deleteTrackingCookiesIfNecessary();
    location.reload();
  }

  private deleteTrackingCookiesIfNecessary() {
    if (!this.matomoCookieService.isTrackingAllowed()) {
      this.optOutMessage.publish();
    }
  }
}
